import workforce from './widgets/workforce';
import modelsOfPractice from './widgets/modelsOfPractice';
import chronicConditions from './widgets/chronicConditions';
import healthOfficeVisits from './widgets/healthOfficeVisits';

export default [workforce, modelsOfPractice, chronicConditions, healthOfficeVisits];
